import React, {Component, Fragment} from 'react';
import ReadyButton from 'components/ReadyButton';
import AudioPlayer from 'components/AudioPlayer';
import strings from 'strings';

import no_sm_intro from 'assets/sounds/no/intros/New-intro-nonword-BM.mp3';
import nn_sm_intro from 'assets/sounds/nn/intros/New-intro-nonword-NN.mp3';

class IntroNonwords extends Component {
	constructor(props) {
		super(props);
		this.audio = strings.getLanguage() === 'nn' ? nn_sm_intro : no_sm_intro;
	}
	render() {
		return (
			<Fragment>
				<p>
					<AudioPlayer autoplay inline src={this.audio} />
					{strings.nono_intro1}
					<br />
				</p>
			</Fragment>
		);
	}
}

export default IntroNonwords;
